export const Types = {
  UPDATE_FIELD: '@indicacao/UPDATE_FIELD',
  UPDATE_RESPOSTA: '@indicacao/UPDATE_RESPOSTA',
  SET_TIPO_INDICACAO: '@indicacao/SET_TIPO_INDICACAO',
  SEARCH_CNPJ: '@indicacao/SEARCH_CNPJ',
  SEARCH_ENDERECO: '@indicacao/SEARCH_ENDERECO',
  SEARCH_SUCCESS: '@indicacao/SEARCH_SUCCESS',
  SEARCH_FAILURE: '@indicacao/SEARCH_FAILURE',
  SEARCH_ENDERECO_FAILURE: '@indicacao/SEARCH_ENDERECO_FAILURE',
  RESET: '@indicacao/RESET',
  CHANGE_STEP: '@indicacao/NEXT_STEP',
  SET_STEP: '@indicacao/SET_STEP',
  FINISH_INDICACAO_REQUEST: '@indicacao/FINISH_INDICACAO_REQUEST',
  FINISH_INDICACAO_SUCCESS: '@indicacao/FINISH_INDICACAO_SUCCESS',
  FINISH_INDICACAO_FAILURE: '@indicacao/FINISH_INDICACAO_FAILURE',
  SET_INFO_ENDERECO: '@indicacao/SET_INFO_ENDERECO',
};

// Actions
export function updateField(field, value) {
  return {
    type: Types.UPDATE_FIELD,
    payload: {
      field,
      value,
    },
  };
}

export function setTipoIndicacao(tipo) {
  return {
    type: Types.SET_TIPO_INDICACAO,
    payload: tipo,
  };
}

export function searchCnpj(cnpj) {
  return {
    type: Types.SEARCH_CNPJ,
    payload: cnpj,
  };
}

export function searchEndereco({
  endereco,
  numero,
  bairro,
  estado,
  cidade,
  cep,
  nomeFantasia,
  latitude,
  longitude,
  telefone,
}) {
  return {
    type: Types.SEARCH_ENDERECO,
    payload: {
      endereco,
      numero,
      bairro,
      estado,
      cidade,
      cep,
      latitude,
      longitude,
      nomeFantasia,
      telefone,
    },
  };
}

export function searchSuccess(response) {
  return {
    type: Types.SEARCH_SUCCESS,
    payload: response,
  };
}

export function searchFailure(response) {
  return {
    type: Types.SEARCH_FAILURE,
    payload: response,
  };
}

export function searchEnderecoFailure(response) {
  return {
    type: Types.SEARCH_ENDERECO_FAILURE,
    payload: response,
  };
}

export function reset() {
  return {
    type: Types.RESET,
  };
}

export function setStep(step) {
  return {
    type: Types.SET_STEP,
    payload: step,
  };
}

export function prevStep() {
  return {
    type: Types.CHANGE_STEP,
    payload: -1,
  };
}

export function nextStep() {
  return {
    type: Types.CHANGE_STEP,
    payload: 1,
  };
}

export function finishIndicacaoRequest(data) {
  return {
    type: Types.FINISH_INDICACAO_REQUEST,
    payload: data,
  };
}

export function finishIndicacaoSuccess() {
  return {
    type: Types.FINISH_INDICACAO_SUCCESS,
  };
}

export function finishIndicacaoFailure() {
  return {
    type: Types.FINISH_INDICACAO_FAILURE,
  };
}

export function updateResposta(codigo, produtos, required) {
  return {
    type: Types.UPDATE_RESPOSTA,
    payload: { codigo, produtos, required },
  };
}

export function setInfoEndereco(endereco) {
  return {
    type: Types.SET_INFO_ENDERECO,
    payload: { endereco },
  };
}
